import { useTranslation } from "react-i18next";
import { useRegistrationForm } from "../provider/registrationFormProviderContext";
import { RegistrationDefaultEndPage } from "./RegistrationDefaultEndPage";

export const RegistrationEditedPage = () => {
	const { t } = useTranslation();
	const { registrationForm } = useRegistrationForm();

	return (
		<RegistrationDefaultEndPage
			headline={t("Changes confirmed")}
			text={t("Your changes will now be reflected in the system.")}
			blockId={registrationForm.editedBlockId}
		/>
	);
};
